import Wrapper from './components/Wrapper';
import Content from './components/Content';

const SplitLayout = {
  Wrapper,
  Content,
};

export default SplitLayout;
